const CrudType = {
  CREATE: 1,
  READ: 2,
  UPDATE: 3,
  DELETE: 4,
  BACKGROUND_READ: 5,
};
// eslint-disable-next-line import/prefer-default-export
export { CrudType };
